import {useEffect, useRef} from 'react';
import {useLocation, useSearchParams} from 'react-router-dom';
import ReactGA from 'react-ga4';
import {useSendAnalyticsEventMutation} from '../../../app/services/analyticsApi';

export const useAnalytics = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const campaignRef = useRef(searchParams.get('campaign') ?? '');
  const sourceRef = useRef(searchParams.get('source') ?? '');
  const visitSentRef = useRef(false);
  const [sendAnalyticsEvent] = useSendAnalyticsEventMutation();

  useEffect(() => {
    let campaign = campaignRef.current;

    try {
      campaign = atob(campaignRef.current);
    } catch (e) {
      // ignore
    }

    const eventData = {
      campaign,
      domain: window.location.host,
      page: location.pathname,
      referrer: document.referrer,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
      source: sourceRef.current,
      width: window.innerWidth,
    };

    if (!visitSentRef.current) {
      sendAnalyticsEvent({eventName: 'visit', eventData: eventData});
      visitSentRef.current = true;
    }

    ReactGA.send({hitType: 'pageview', page: location.pathname});
    sendAnalyticsEvent({eventName: 'pageview', eventData});
  }, [location]);
};
